import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import ChatAnalytics from "components/ChatAnalytics/ChatAnalytics";

import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as artifactReducer from "containers/LanguageModelArtifact/reducer";
import * as viewReducer from "containers/View/reducer";
import * as adminReducer from "containers/Admin/reducer";
import * as globalReducer from "containers/App/reducer";
import * as reportReducer from "containers/Report/ReportReducer";

class ChatAnalyticsContainer extends React.Component {
  constructor(props) {
    super(props);

    props.initChatAnalytics();
  }

  render() {
    return <ChatAnalytics {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    initChatAnalytics: () => dispatch(viewReducer.initChatAnalytics()),
    updateFilterModel: (filterModel) => dispatch(viewReducer.updateFilterModel(filterModel)),
    updateFilterQA: (filterQA) => dispatch(viewReducer.updateFilterQA(filterQA)),
    updateFilterUseCase: (filterUseCase) => dispatch(viewReducer.updateFilterUseCase(filterUseCase))
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    fineTuneDataList: artifactReducer.getFineTuningDataList(state),
    fineTuneModelList: artifactReducer.getFineTunedModelList(state),
    corpusList: artifactReducer.getCorpusList(state),

    modelOptions: chatGPTReducer.getModelOptions(state),

    isLoadingChatAnalytics: viewReducer.getIsLoadingChatAnalytics(state),
    chatBlueprints: viewReducer.getChatBlueprints(state),
    filter_model_option: viewReducer.getFilterModelOption(state),
    filter_qa_option: viewReducer.getFilterQAOption(state),
    filter_use_option: viewReducer.getFilterUseCaseOption(state),

    artifactFeedback: viewReducer.getArtifactFeedback(state),
    allChats: viewReducer.getAllChats(state),
    datasets: viewReducer.getDatasets(state),

    users: adminReducer.getUsers(state),

    reports: reportReducer.getReports(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ChatAnalyticsContainer);
